import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { MessageService } from './message.service';
import { TransactionStatusEnum } from '../models/lookups.enum';
import { InvoiceModel, InvoiceItemModel, OrderModel, OrderItemModel } from '../models/invoice.model';

@Injectable({
	providedIn: 'root'
})

export class InvoiceService extends BaseService {

	public transactionStatusEnum: TransactionStatusEnum = new TransactionStatusEnum();

	constructor(private http: HttpClient) {
		super();
	}

	public getStoreOrder(key: string, orderRef: string) {
		var reqUri = environment.commonApiUrl + 'store/getorder?key=' + this.cleanseUrlParam(key) + '&orderRef=' + this.cleanseUrlParam(orderRef);
		return this.http.get<any>(reqUri, super.getHeaders());
	}

	public getRetryOrder(key: string) {
		var reqUri = environment.commonApiUrl + 'store/retryorder?key=' + this.cleanseUrlParam(key);
		return this.http.get<any>(reqUri, super.getHeaders());
	}

	public getAnOrder() {
		var reqUri = environment.commonApiUrl + 'store/getanorder';
		return this.http.get<any>(reqUri, super.getHeaders());
	}

	public getClientTaxProfile(refDate: string) {
		var reqUri = environment.commonApiUrl + 'store/gettaxprofile?applicationKey=' + this.cleanseUrlParam(environment.appToken) + '&refDate=' + this.cleanseUrlParam(refDate);
		return this.http.get<any>(reqUri, super.getHeaders());
	}

	public updateOrder(key: string, orderRef: string, order: OrderModel){    
		var reqUri = environment.commonApiUrl + 'store/updateorder?key=' + this.cleanseUrlParam(key) + '&orderRef=' + this.cleanseUrlParam(orderRef);
		var body = JSON.stringify(order);
		return this.http.put<any>(reqUri, body, super.getHeaders());
	}

	public getProcessorProfile(chargeTotal: number, orderRefNo: string, orderKey: string, email: string, orderItems: any[]) {
		var reqUri = environment.commonApiUrl + 'cardprocessor/getprocessorprofile?chargeTotal=' + this.cleanseUrlParam((chargeTotal).toFixed(2)) + '&invoiceNumber=' + this.cleanseUrlParam(orderRefNo) + '&invoiceId=' + this.cleanseUrlParam(orderKey) + '&contactEmail=' + this.cleanseUrlParam(email) + '&applicationKey=' + this.cleanseUrlParam(environment.appToken);
		var body = JSON.stringify(orderItems);
		return this.http.post<any>(reqUri, body, super.getHeaders());
	}

	public processPaymentResponse(activeInvoice: InvoiceModel) {
		var reqUri = environment.commonApiUrl + 'store/processproviderpayment?key=' + this.cleanseUrlParam(activeInvoice.orderKey);
		activeInvoice.processingAppKey = environment.appToken;
		var body = JSON.stringify(activeInvoice);
		return this.http.put<any>(reqUri, body, super.getHeaders());
	}

	public getActiveInvoice(key: string, invoiceNumber: string, amountPaid: number) {
		var reqUri = environment.commonApiUrl + 'store/getinvoice?key=' + this.cleanseUrlParam(key) + '&invoiceNumber=' + this.cleanseUrlParam(invoiceNumber) + '&amountPaid=' + this.cleanseUrlParam(amountPaid);
		return this.http.get<any>(reqUri, super.getHeaders());
	}

	public getVelocityOrder(remittanceId: string, securityId: string) {
		var reqUri = environment.commonApiUrl + 'store/getvelocityorderbyref?remittanceId=' + this.cleanseUrlParam(remittanceId) + '&securityId=' + this.cleanseUrlParam(securityId);
		return this.http.get<any>(reqUri, super.getHeaders()).toPromise();
	}

	public getActiveOrder(orderRefNumber: string) {
		var reqUri = environment.commonApiUrl + 'store/getopenedgeorder?orderRefNumber=' + this.cleanseUrlParam(orderRefNumber);
		return this.http.get<any>(reqUri, super.getHeaders());
	}

	public logFailedRequest(key: string, error: string, failedRequest: any){
		var reqUri = environment.commonApiUrl + 'store/logerror?key=' + this.cleanseUrlParam(key) + '&error=' + this.cleanseUrlParam(error);
		var body = JSON.stringify(failedRequest);
		return this.http.post<any>(reqUri, body, super.getHeaders());
	}
}
